<template>
    <el-scrollbar class="data-evaluation">
        <div class="data-evaluation_title">
            班级数据魔方

            <el-select v-model="course_id" placeholder="请选择" @change="handleChangeCourse">
                <el-option v-for="item in courseList" :key="item.course_id" :label="item.course_name" :value="item.course_id"> </el-option>
            </el-select>

            <el-select v-model="class_id" placeholder="请选择" @change="handleChangeClass" v-if="role === 3">
                <el-option v-for="item in classList" :key="item.c_id" :label="item.c_name" :value="item.c_id"> </el-option>
            </el-select>
        </div>

        <div class="data-evaluation_box">
            <div class="box-top">
                <div class="data-radar">
                    <div class="data-radar_title">评价雷达图</div>

                    <div class="data-radar_chart" ref="dataRadarChartRef"></div>
                </div>

                <div class="data-ranking">
                    <div class="data-ranking_title">
                        <span>个人排行</span>

                        <el-button type="primary" icon="el-icon-upload2" @click="handleExport" v-if="role === 3">导出</el-button>
                    </div>

                    <!-- 教师 -->
                    <template v-if="role === 3">
                        <div class="data-ranking_table">
                            <el-table
                                :data="rankingData"
                                style="
                            width: 100%;
                            flex: 1;
                            border: 1px solid #f2f4f7;
                            border-radius: 4px;
                            height: 100%
                        "
                                size="medium"
                                :header-cell-style="{
                                    fontWeight: 'normal',
                                    color: '#333',
                                    background: '#f5f7fa',
                                }"
                                :cell-style="{ fontSize: '12px', color: '#333' }"
                                height="100%"
                            >
                                <el-table-column type="index" label="排行" :align="'center'" width="100"> </el-table-column>
                                <el-table-column prop="s_name" label="姓名" :align="'center'"> </el-table-column>
                                <el-table-column label="成绩" :align="'center'" width="100">
                                    <!-- 综合得分 -->
                                    <template slot-scope="scope">{{ scope.row.comp_score.toFixed(2) }}</template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </template>

                    <!-- 学生 -->
                    <template v-else-if="role === 4">
                        <div class="data-ranking_sort">
                            <div class="sort-img">
                                <img src="@/assets/images/ranking-icon.png" alt="" />

                                <div class="sort-score" ref="sortScoreRef">
                                    <div class="sort-score-ref" ref="rankingScoreRef">
                                        {{ rankingData[0] ? getScore(rankingData[0].comp_score) : 0 }}
                                    </div>
                                    <div class="sort-score-label">分</div>
                                </div>
                                <!-- <div class="sort-score"></div> -->
                            </div>

                            <div class="sort-ranking">
                                第
                                <span>{{ rankingData[0] && rankingData[0].rank }}</span>
                                名
                            </div>
                        </div>
                    </template>
                </div>
            </div>

            <div class="box-bottom">
                <div class="score-item" v-for="scoreItem in scoreOptions" :key="scoreItem.key">
                    <div class="score-item_top">
                        <div class="top-label">{{ scoreItem.label }}</div>
                        <div class="top-enter" v-if="scoreItem.isEnter" @click="handleEnterDetail(scoreItem)">
                            <img src="@/assets/icons/enter-icon.svg" alt="" />
                            <span>进入</span>
                        </div>
                    </div>

                    <div class="score-item_bottom">
                        <el-progress
                            type="circle"
                            :percentage="evaluationData[scoreItem.key]"
                            :width="160"
                            :stroke-width="12"
                            stroke-linecap="butt"
                            :color="scoreItem.color"
                            :show-text="false"
                        ></el-progress>

                        <div class="progress-text">{{ evaluationData[scoreItem.key] }}</div>
                    </div>
                </div>
            </div>
        </div>
    </el-scrollbar>
</template>

<script>
import * as XLSX from "xlsx";

export default {
    name: "DataEvaluation",
    data() {
        return {
            evaluationData: {
                knowledge_score: 0, //知识考核平均分
                attitude_score: 0, //态度考核平均分
                training_score: 0, //技能考核平均分
                quality_score: 0, //素养考核评价分
                quiz_score: 0, //考核平均分
                rank_score: 0,
            },
            scoreOptions: [
                { type: "knowledge", key: "knowledge_score", label: "知识考核平均分", isEnter: true, color: "#165DFF" },
                { type: "attitude", key: "attitude_score", label: "态度考核平均分", isEnter: true, color: "#4FD1C5" },
                { type: "training", key: "training_score", label: "技能考核平均分", isEnter: true, color: "#FEAE65" },
                { type: "quality", key: "quality_score", label: "素养考核平均分", isEnter: true, color: "#165DFF" },
                { type: "exam", key: "quiz_score", label: "期末考核分数", isEnter: true, color: "#4FD1C5" },
                { key: "rank_score", label: "期末综合成绩", isEnter: false, color: "#FEAE65" },
            ],
            rankingData: [],
            chartMap: new Map(),
            role: Number(localStorage.getItem("role")),
            courseList: [],
            course_id: undefined,
            class_id: Number(localStorage.getItem("class_id")),
            classList: [],
        };
    },
    // created() {},
    mounted() {
        this.getCourseList();

        // this.getEvaluationData();
        // this.getRankingData();
        window.addEventListener("resize", this.resizeChart);
    },
    methods: {
        // 获得班级列表
        getClassList() {
            const params = {
                course_id: this.course_id,
            };

            this.$shttp.axiosGetBy(this.$api.jdCourseClList, params, (res) => {
                if (res.code === 200) {
                    this.classList = res.data || [];

                    const classIdList = this.classList.map((item) => item.c_id);
                    if (classIdList.length === 0) {
                        this.class_id = undefined;
                    } else if (!classIdList.includes(this.class_id)) {
                        this.class_id = classIdList[0];
                    }

                    if (this.class_id) {
                        this.getRankingData();
                    }
                }
            });
        },

        // 获取课程列表
        getCourseList() {
            if (this.role === 3) {
                this.$shttp.axiosGet(this.$api.showTeaCourse, (res) => {
                    if (res.code === 200) {
                        this.courseList = res.data.course_list || [];

                        if (this.courseList.length > 0) {
                            this.course_id = this.courseList[0].course_id;

                            this.getClassList();
                            this.getEvaluationData();
                            // this.getRankingData();
                        }
                    }
                });
            } else if (this.role === 4) {
                // /admin/courseLists
                const params = {
                    type: 1,
                    parent_id: "no",
                    sort: 1,
                };

                this.$shttp.axiosGetBy(this.$api.admin_courseLists, params, (res) => {
                    if (res.code === 200) {
                        this.courseList = res.list || [];

                        if (this.courseList.length > 0) {
                            this.course_id = this.courseList[0].course_id;

                            this.getEvaluationData();
                            this.getRankingData();
                        }
                    }
                });
            }
        },

        getScore(score) {
            this.$nextTick(() => {
                this.adjustFontSize();
            });

            // 检查数字是否包含小数部分
            if (score % 1 !== 0) {
                // 获取小数部分的长度
                let decimalPart = score.toString().split(".")[1];

                if (decimalPart && decimalPart.length > 3) {
                    // 小数部分大于3位，保留两位小数
                    return score.toFixed(2);
                }
            }

            return score;
        },

        // 导出
        handleExport() {
            const data = [];
            this.rankingData.forEach((item) => {
                const jsonItem = {
                    学号: item.s_account,
                    姓名: item.s_name,
                    态度成绩: item.detail_scores.attitude_score,
                    知识成绩: item.detail_scores.knowledge_score,
                    技能成绩: item.detail_scores.practice_score,
                    素养成绩: item.detail_scores.literacy_score,
                    考试成绩: item.exam_results,
                    综合成绩: item.comp_score,
                };
                data.push(jsonItem);
            });

            // 导出为 Excel 文件
            const ws = XLSX.utils.json_to_sheet(data); // 将 JSON 数据转化为 Excel 表格
            const wb = XLSX.utils.book_new(); // 创建一个新的工作簿
            XLSX.utils.book_append_sheet(wb, ws, "Sheet1"); // 将表格数据添加到工作簿

            // 导出文件并下载
            XLSX.writeFile(wb, "个人排行数据.xlsx");
        },

        getEvaluationData() {
            const params = {
                course_id: this.course_id,
            };

            if (this.role === 3) params.c_id = this.class_id;

            this.$shttp.axiosGetBy(
                this.$api.data_evaluation_index,
                params,
                (res) => {
                    if (res.code === 200) {
                        this.evaluationData = res.data;

                        this.setRadarChart();
                    } else {
                        this.setRadarChart();
                        this.$message.error(res.msg);
                    }
                },
                (error) => {
                    this.setRadarChart();
                },
            );
        },

        getRankingData() {
            const class_id = this.role === 3 ? this.class_id : Number(localStorage.getItem("c_id"));

            const params = {
                course_id: this.course_id,
                class_id: class_id,
            };

            this.$shttp.axiosPost(
                this.$api.jdCourseRankingGetRanking,
                params,
                (res) => {
                    if (res.code === 200) {
                        this.rankingData = res.data;
                    } else {
                        this.$message.error(res.msg);
                    }
                },
                (error) => {
                    const errorData = error.response.data;
                    this.$message.error(errorData.msg);
                },
            );
        },

        adjustFontSize() {
            const sortScoreRef = this.$refs.sortScoreRef;
            const rankingScoreRef = this.$refs.rankingScoreRef;

            let fontSize = 80;

            while (rankingScoreRef.clientWidth > sortScoreRef.clientWidth - 30) {
                fontSize -= 1;
                rankingScoreRef.style.fontSize = `${fontSize}px`;
            }

            // rankingScoreRef.style.fontSize = `${fontSize}px`;
        },

        setRadarChart() {
            if (!this.$refs.dataRadarChartRef) return;
            const chart = this.$echarts.init(this.$refs.dataRadarChartRef);
            const data = [
                this.evaluationData.attitude_score,
                this.evaluationData.knowledge_score,
                this.evaluationData.training_score,
                this.evaluationData.quality_score,
            ];
            const indexSet = new Set();

            const options = {
                tooltip: {
                    show: true,
                    borderWidth: 0,
                    backgroundColor: "#ffffff",
                    extraCssText:
                        "box-shadow: 0px 8px 10px -5px rgba(0,0,0,0.08), 0px 16px 24px 2px rgba(0,0,0,0.04), 0px 6px 30px 5px rgba(0,0,0,0.05);",
                    formatter: function(params) {
                        const value = params.data.value;

                        return `
                            <div class="radar-tooltip">
                                <div class="tooltip-item">
                                    <div class="tooltip-item_title">态度</div>
                                    <div class="tooltip-item_score">
                                        <span>分数：</span>
                                        <span>${value[0]}</span>
                                    </div>
                                </div>

                                <div class="tooltip-item">
                                    <div class="tooltip-item_title">知识</div>
                                    <div class="tooltip-item_score">
                                        <span>分数：</span>
                                        <span>${value[1]}</span>
                                    </div>
                                </div>

                                <div class="tooltip-item">
                                    <div class="tooltip-item_title">素养</div>
                                    <div class="tooltip-item_score">
                                        <span>分数：</span>
                                        <span>${value[2]}</span>
                                    </div>
                                </div>

                                <div class="tooltip-item">
                                    <div class="tooltip-item_title">技能</div>
                                    <div class="tooltip-item_score">
                                        <span>分数：</span>
                                        <span>${value[3]}</span>
                                    </div>
                                </div>
                            </div>
                        `;
                    },
                },
                radar: [
                    {
                        indicator: [
                            { text: "态度", max: 100 },
                            { text: "知识", max: 100 },
                            { text: "素养", max: 100 },
                            { text: "技能", max: 100 },
                        ],
                        axisLine: {
                            //指向外圈文本的分隔线样式
                            lineStyle: {
                                color: ["#C9CDD4"],
                            },
                        },
                        splitLine: {
                            lineStyle: {
                                color: ["#E5E6EB"],
                            },
                        },
                        splitArea: {
                            areaStyle: {
                                color: ["#ffffff"],
                            },
                        },
                        name: {
                            textStyle: {
                                color: "#1D2129",
                                fontSize: 14,
                            },
                        },
                        center: ["50%", "50%"],
                        axisLabel: {
                            show: true, // 显示刻度的标签值
                            color: "#1D2129", // 设置刻度线的标签文字颜色为黑色
                            fontSize: 14, // 设置刻度线的标签字体大小
                            formatter: function(value, index) {
                                if (value === 0 || indexSet.has(index)) return "";

                                indexSet.add(index);
                                return value; // 默认显示数值
                            },
                            verticalAlign: "middle",
                            align: "center",
                            margin: 0, // 设置标签与坐标轴之间的间距，调节此值可以实现一些位移效果
                        },
                    },
                    // {
                    //     indicator: [{ text: "态度", max: 100 }],
                    //     center: ["50%", "50%"],
                    //     name: {
                    //         show: false,
                    //     },
                    // },
                    // {
                    //     indicator: [{ text: "知识", max: 100 }],
                    //     center: ["50%", "50%"],
                    //     startAngle: 180,
                    //     name: {
                    //         show: false,
                    //     },
                    // },
                    // {
                    //     indicator: [{ text: "素养", max: 100 }],
                    //     center: ["50%", "50%"],
                    //     startAngle: 270,
                    //     name: {
                    //         show: false,
                    //     },
                    // },
                    // {
                    //     indicator: [{ text: "技能", max: 100 }],
                    //     center: ["50%", "50%"],
                    //     startAngle: 360,
                    //     name: {
                    //         show: false,
                    //     },
                    // },
                ],
                series: [
                    {
                        type: "radar",
                        symbol: "circle",
                        // silent: true,
                        areaStyle: {
                            color: "rgba(22,93,255,0.15)",
                        },
                        lineStyle: {
                            color: "#165DFF",
                        },
                        symbolSize: 10,
                        itemStyle: {
                            color: "#165DFF",
                        },
                        triggerEvent: true,
                        data: [{ value: data }],
                    },

                    // // 态度考核
                    // {
                    //     type: "radar",
                    //     symbol: "circle",
                    //     radarIndex: 1,
                    //     silent: false,
                    //     symbolSize: 10,
                    //     itemStyle: {
                    //         color: "#165DFF",
                    //     },
                    //     label: {
                    //         show: false,
                    //     },
                    //     data: [{ value: [this.evaluationData.attitude_score] }],
                    // },

                    // // 知识
                    // {
                    //     type: "radar",
                    //     symbol: "circle",
                    //     radarIndex: 2,
                    //     silent: false,
                    //     symbolSize: 10,
                    //     itemStyle: {
                    //         color: "#165DFF",
                    //     },
                    //     data: [{ value: [this.evaluationData.knowledge_score] }],
                    // },

                    // // 素养
                    // {
                    //     type: "radar",
                    //     symbol: "circle",
                    //     radarIndex: 3,
                    //     silent: false,
                    //     symbolSize: 10,
                    //     itemStyle: {
                    //         color: "#165DFF",
                    //     },
                    //     data: [{ value: [this.evaluationData.training_score] }],
                    // },

                    // // 知识
                    // {
                    //     type: "radar",
                    //     symbol: "circle",
                    //     radarIndex: 4,
                    //     silent: false,
                    //     symbolSize: 10,
                    //     itemStyle: {
                    //         color: "#165DFF",
                    //     },
                    //     data: [{ value: [this.evaluationData.quality_score] }],
                    // },
                ],
            };

            chart.setOption(options);

            if (!this.chartMap.has("radarChart")) {
                this.chartMap.set("radarChart", chart);
            }
        },

        resizeChart() {
            for (const [_, value] of this.chartMap) {
                value.resize();
            }
        },

        // 修改课程
        handleChangeCourse(val) {
            this.evaluationData = {
                knowledge_score: 0, //知识考核平均分
                attitude_score: 0, //态度考核平均分
                training_score: 0, //技能考核平均分
                quality_score: 0, //素养考核评价分
                quiz_score: 0, //考核平均分
                rank_score: 0,
            };
            this.rankingData.splice(0);
            this.chartMap.clear();

            this.course_id = val;

            if (this.role === 3) {
                this.class_id = Number(localStorage.getItem("class_id"));
                this.getClassList();
            }
            this.getEvaluationData();
            // this.getRankingData();
        },

        //修改班级
        handleChangeClass(val) {
            this.evaluationData = {
                knowledge_score: 0, //知识考核平均分
                attitude_score: 0, //态度考核平均分
                training_score: 0, //技能考核平均分
                quality_score: 0, //素养考核评价分
                quiz_score: 0, //考核平均分
                rank_score: 0,
            };
            this.rankingData.splice(0);
            this.chartMap.clear();

            this.class_id = val;
            this.getEvaluationData();
            this.getRankingData();
        },

        handleEnterDetail(item) {
            if (this.role === 3) {
                if (!this.class_id) {
                    this.$message.warning("请先选择班级");
                    return;
                } else if (!this.course_id) {
                    this.$message.warning("请先选择课程");
                    return;
                }

                this.enterTeacherDetail(item);
            } else if (this.role === 4) {
                this.enterStudentDetail(item);
            }
        },

        // 教师进入详情
        enterTeacherDetail(item) {
            let routePath = "";

            if (item.type === "quality") {
                // 素养考核
                routePath = "/qualityCourse/teacher/dataEvaluationIndex/literacy";
            } else if (item.type === "training") {
                // 技能考核
                routePath = "/qualityCourse/teacher/dataEvaluationIndex/training";
            } else if (item.type === "attitude") {
                // 态度考核
                routePath = "/qualityCourse/teacher/dataEvaluationIndex/attitude";
            } else if (item.type === "knowledge") {
                // 知识考核
                routePath = "/qualityCourse/teacher/dataEvaluationIndex/knowledge";
            } else if (item.type === "exam") {
                // 考试成绩
                routePath = "/qualityCourse/teacher/dataEvaluationIndex/exam";
            }

            if (routePath !== "") {
                this.$router.push({
                    path: routePath,
                    query: {
                        course_id: this.course_id,
                        class_id: this.class_id,
                    },
                });
            }
        },

        // 学生进入详情
        enterStudentDetail(item) {
            let routePath = "";

            if (item.type === "quality") {
                routePath = "/qualityCourse/student/dataEvaluationIndex/literacy";
            } else if (item.type === "training") {
                // 技能考核
                routePath = "/qualityCourse/student/dataEvaluationIndex/training";
            } else if (item.type === "attitude") {
                // 态度考核
                routePath = "/qualityCourse/student/dataEvaluationIndex/attitude";
            } else if (item.type === "knowledge") {
                // 知识考核
                routePath = "/qualityCourse/student/dataEvaluationIndex/knowledge";
            } else if (item.type === "exam") {
                // 考试成绩
                routePath = "/qualityCourse/student/dataEvaluationIndex/exam";
            }

            if (routePath !== "") {
                this.$router.push({
                    path: routePath,
                    query: {
                        course_id: this.course_id,
                    },
                });
            }
        },
    },
    destroyed() {
        window.removeEventListener("resize", this.resizeChart);
    },
};
</script>

<style lang="scss" scoped>
::v-deep .radar-tooltip {
    padding: 14px;
    color: #333333;

    .tooltip-item {
        &:not(.tooltip-item:last-of-type) {
            margin-bottom: 10px;
        }

        &_title {
            font-family: PingFang-SC, PingFang-SC;
            font-weight: 400;
            font-size: 14px;
            line-height: 22px;
        }

        &_score {
            display: flex;
            align-items: center;
            gap: 70px;
            font-family: PingFang-SC, PingFang-SC;
            font-weight: 400;
            font-size: 14px;
            line-height: 22px;
        }
    }
}

::v-deep .el-table th.gutter {
    background-color: #f5f7fa;
}

::v-deep .el-table__body-wrapper {
    /* 设置滚动条的宽度 */
    &::-webkit-scrollbar {
        width: 8px; /* 垂直滚动条宽度 */
        height: 8px; /* 水平滚动条高度 */
    }

    /* 设置滚动条轨道样式 */
    &::-webkit-scrollbar-track {
        background-color: transparent; /* 轨道颜色 */
        border-radius: 8px;
    }

    /* 设置滚动条滑块样式 */
    &::-webkit-scrollbar-thumb {
        background-color: #d4d5d7; /* 滑块颜色 */
        border-radius: 8px;
    }

    /* 滑块悬停时的样式 */
    &::-webkit-scrollbar-thumb:hover {
        background-color: #c1c3c6; /* 悬停时的颜色 */
    }
}

.data-evaluation {
    width: 100%;
    // height: 100%;
    height: calc(100vh - 70px);
    padding: 20px;
    box-sizing: border-box;
    background-color: #efefef;
    // background-color: #333;

    ::v-deep .el-scrollbar__wrap {
        margin: 0 !important;
        &::-webkit-scrollbar {
            display: none;
        }
    }

    &_title {
        font-family: PingFang-SC, PingFang-SC;
        height: 40px;
        font-weight: 800;
        font-size: 24px;
        color: #333333;
        line-height: 24px;
        margin-bottom: 20px;
        display: flex;
        align-items: center;
        gap: 10px;
    }

    &_box {
        height: calc(100% - 60px);
        // background-color: black;

        .box-top {
            width: 100%;
            // height: calc(100% - 306px);
            height: 474px;
            // background-color: #ffffff;
            display: flex;
            gap: 16px;
            align-items: center;

            .data-radar,
            .data-ranking {
                width: calc((100% - 16px) / 2);
                height: 100%;
                background-color: #ffffff;
                border-radius: 8px;
                padding: 24px;
                box-sizing: border-box;
            }

            .data-radar {
                &_title {
                    height: 24px;
                    font-family: PingFang-SC, PingFang-SC;
                    font-weight: 500;
                    font-size: 16px;
                    color: #333333;
                    line-height: 24px;
                    margin-bottom: 10px;
                }

                &_chart {
                    height: calc(100% - 34px);
                    // transform: scaleX(0.8);
                }
            }

            .data-ranking {
                &_title {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    margin-bottom: 10px;
                    height: 32px;

                    span {
                        font-family: PingFang-SC, PingFang-SC;
                        font-weight: 500;
                        font-size: 16px;
                        color: #333333;
                        line-height: 24px;
                    }

                    .el-button {
                        width: 87px;
                        height: 32px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                    }
                }

                &_table {
                    height: calc(100% - 60px);
                    // background-color: #000000;
                    overflow: hidden;
                }

                &_sort {
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    // height: calc(100vh - 600px);
                    // background-color: rgba($color: #000000, $alpha: 0.1);
                    overflow: hidden;

                    .sort-img {
                        width: 300px;
                        height: 310px;
                        position: relative;
                        // background-color: rgba($color: #000000, $alpha: 0.2);
                        display: flex;
                        align-items: center;
                        justify-content: center;

                        img {
                            width: 100%;
                            height: 100%;
                            object-fit: cover;
                            position: absolute;
                            inset: 0;
                        }

                        .sort-score {
                            // background-color: rgba($color: #000000, $alpha: 0.3);
                            transform: translateY(-5px);
                            width: 160px;
                            height: 100px;
                            font-family: PingFang-SC, PingFang-SC;
                            font-weight: bold;
                            font-size: 80px;
                            color: #ffffff;
                            box-sizing: border-box;
                            z-index: 999;

                            display: flex;
                            align-items: center;
                            justify-content: center;

                            .sort-score-ref {
                                height: 100%;
                                display: flex;
                                justify-content: flex-end;
                                align-items: center;
                                margin-left: 5px;
                            }

                            .sort-score-label {
                                font-size: 18px;
                                font-family: PingFang-SC, PingFang-SC;
                                align-self: flex-end;
                                padding-bottom: 20px;
                            }
                        }
                    }

                    .sort-ranking {
                        font-family: PingFang-SC, PingFang-SC;
                        font-weight: bold;
                        font-size: 24px;
                        color: #232f7a;

                        span {
                            font-size: 48px;
                            // margin-inline: 2px;
                        }
                    }
                }
            }
        }

        .box-bottom {
            margin-top: 20px;
            width: 100%;
            height: 286px;
            // background-color: #ffffff;
            display: flex;
            gap: 16px;
            align-items: center;

            .score-item {
                width: calc((100% - 80px) / 6);
                height: 100%;
                background-color: #ffffff;
                border-radius: 8px;
                box-sizing: border-box;
                padding: 24px;
                overflow: hidden;

                &_top {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;

                    .top-label {
                        font-family: PingFang-SC, PingFang-SC;
                        font-weight: 500;
                        font-size: 16px;
                        color: #000000;
                        flex-shrink: 0;
                    }

                    .top-enter {
                        display: flex;
                        align-items: center;
                        gap: 4px;
                        cursor: pointer;

                        img {
                            width: 16px;
                            height: 16px;
                            object-fit: cover;
                        }

                        span {
                            font-family: PingFang-SC, PingFang-SC;
                            font-weight: 400;
                            font-size: 12px;
                            color: #006eff;
                            flex-shrink: 0;
                        }
                    }
                }

                &_bottom {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin-top: 40px;
                    position: relative;
                    width: 160px;
                    height: 160px;
                    margin-inline: auto;

                    .el-progress {
                        position: absolute;
                        inset: 0;
                    }

                    .progress-text {
                        font-family: PingFang-SC, PingFang-SC;
                        font-weight: 600;
                        font-size: 36px;
                        color: #000000;
                    }
                }
            }
        }
    }
}
</style>
